import { Injectable, signal, computed } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Client } from '../../../../core/models/client.model';

/**
 * Service to share POS state with the main toolbar
 * This allows the toolbar to display POS-specific controls
 */
@Injectable({
  providedIn: 'root',
})
export class PosToolbarService {
  // Product search
  searchControl = new FormControl('');

  // View mode
  viewMode = signal<'carousel' | 'simple' | 'grid'>('carousel');

  // Client selection
  clientSearchControl = new FormControl('');
  selectedClient = signal<Client | null>(null);
  defaultClient = signal<Client | null>(null);
  filteredClients = signal<Client[]>([]);

  // Computed
  isDefaultClient = computed(() => {
    const selected = this.selectedClient();
    const defaultC = this.defaultClient();
    return selected && defaultC && selected.id === defaultC.id;
  });

  // Callbacks - will be set by POS component
  onViewModeChange: ((mode: 'carousel' | 'simple' | 'grid') => void) | null = null;
  onClientSelect: ((client: Client) => void) | null = null;
  onClientRemove: (() => void) | null = null;
  onAddQuickClient: (() => void) | null = null;
  onEditClient: ((client: Client) => void) | null = null;

  // Check if we're in POS route
  isPosRoute = signal(false);

  // Cashier session state
  hasCashierSession = signal(false);

  // Reset state
  reset() {
    this.searchControl.setValue('');
    this.clientSearchControl.setValue('');
    this.selectedClient.set(null);
    this.filteredClients.set([]);
    this.viewMode.set('carousel');
    this.isPosRoute.set(false);
    this.hasCashierSession.set(false);
  }
}
